import { type Exchange, type ExchangeQueryParams, exchangesEndpoints } from "../../../api";
import { useStrapiList, type UseStrapiListOptions } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

const useExchanges = (props?: UseStrapiListOptions) => {
  const {
    items: exchanges,
    refresh,
    isLoading,
    ...other
  } = useStrapiList<Exchange>({
    ...props,
    load: loadExchanges,
    onLoadError: (err: unknown) => {
      handleError(getErrorMessage(err, "Exchanges loading failed"));
    },
  });

  return {
    exchanges,
    refresh,
    isLoading,
    ...other,
  };
};

export const loadExchanges = async (params?: ExchangeQueryParams) => {
  try {
    return await exchangesEndpoints.getExchanges(params);
  } catch (err: unknown) {
    handleError(getErrorMessage(err, "Exchanges loading failed"));
  }
};

export default useExchanges;
